import React from 'react';
import {Table,TableBody,TableCell,TableContainer ,TableHead,TableRow,makeStyles,Paper,Button,Typography   } from '@material-ui/core';
import {isEmpty,isUndefined} from 'lodash'
import { useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
const useStyles = makeStyles((theme) => ({
  demo: {
      backgroundColor: theme.palette.background.paper,
  },
  title: {
      margin: theme.spacing(1, 1, 1),
  },
    table: {
      borderSpacing:'1px',
      borderCollapse:"separate"
    },
    CellIndex:{
        color: '#6d6d6d',
        background: '#e4e4e4',   
        minWidth:50,      
    },
    CellHeader1:{
        color: '#6d6d6d',
        background: '#e4e4e4',   
        minWidth:100,    
        textAlign: "center",
        border:"1px",
        padding: 0
    },
    CellHeader0:{
        color: '#6d6d6d',
        background: '#e4e4e4',   
        minWidth:50, 
        border:"1px",   
        textAlign: "center",
        padding: 0
    }
  }));
function ExcelVy(props) {
    const ImportSamples = useSelector(state=> state.accountsData.ImportSamples)
    const ImportSamplesFlag = useSelector(state=> state.accountsData.ImportSamplesFlag)
    const classes = useStyles();
    const [ColumnC,setColumnC] = React.useState([])
    const Column1 = [
        "","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O",
        "P","Q","R","S","T","U","V","W","X","Y","Z",
        "AA","AB","AC","AD","AE","AF","AG","AH","AI","AJ","AK","AL","AM","AN","AO",
        "AP","AQ","AR","AS","AT","AU","AV","AW","AX","AY","AZ",
        "BA","BB","BC","BD","BE","BF","BG","BH","BI","BJ","BK","BL","BM","BN","BO",
        "BP","BQ","BR","BS","BT","BU","BV","BW","BX","BY","BZ",
        "CA","CB","CC","CD","CE","CF","CG","CH","CI","CJ","CK","CL","CM","CN","CO",
        "CP","CQ","CR","CS","CT","CU","CV","CW","CX","CY","CZ"
    ]
    React.useEffect(()=>{
      if(!isEmpty(props.Chips)){
        let Culoms = []
        props.Chips.filter(item=>item.Type === 'Column').map(item=>{
          if(isEmpty(Culoms.filter(n=> n.MetaN === item.MetaN))){
            Culoms.push({Meta:item.Meta,MetaN:item.MetaN})
          }
        })
        setColumnC(Culoms)
      }
    },[JSON.stringify(props.Chips)])
   React.useEffect(()=>{
      if(!isEmpty(ImportSamples)){
        if(props.Chips.some(item=>item.MetaN === 'Order_MKostnader')){
          let ImportSamplesArr = ImportSamples[0]
          let ImportSamplesArrMK = Object.keys(ImportSamplesArr).filter(item=>{return item.includes("Order_MKostnader_")})
          if(!isEmpty(ImportSamplesArrMK)){
            let Culoms = ColumnC
            ImportSamplesArrMK.map(item=>{
              Culoms.push({Meta:item.split("_").pop(),MetaN:item})
            })
            setColumnC(Culoms)
          }
        }
      }
    },[ImportSamples])
    /* */
    console.log(ImportSamplesFlag,"DDDDDD")
    return (
        <div>
           <Typography variant="h6" className={classes.title}><u><IntlMessages id="Preview" /></u>
           {
            !isEmpty(props.Chips)?
            <Button variant="contained" color="secondary" size="small" style={{float:"right"}} onClick={props.resetZeroChips}><IntlMessages id="Clear.selections" /></Button>
            :""
           }
           
           </Typography>
    <TableContainer component={Paper} style={{marginTob:10,width:"100%"}}>
      <Table className={classes.table} size="small" aria-label="a dense table">
      <TableHead>
      <TableRow>
        {
            Column1.map((item,index)=>{
                return <TableCell  align="center" className={`${index === 0?classes.CellHeader0:classes.CellHeader1} border`} 
                key={index}><b>{item}</b></TableCell>
            })
        }
       
        </TableRow>
      </TableHead>
      <TableBody>
      
      {[...Array(3)].map((row,index) => (
        <TableRow key={index}>
            {
              [...Array(105)].map((item,index1)=>{
                return <TableCell align="center" className={`${index1 === 0?classes.CellIndex:""} border`} key={index}>
                  {
                  index1 === 0?index+1:
                  /*
                    !isEmpty(props.Chips.filter(item=>item.Type === 'Header'))?
                    index1 === 2 && index === 0?
                    props.Chips.filter(item=>item.Type === 'Header').map(item=>{
                        return item.Value+", "
                    })
                    :index1 === 1 && index === 0?
                    "Rapport"
                    :index1 === 2 && index === 0?
                    "Beskrivning"
                    :""
                    :*/""
                }
                    {
                    !isEmpty(props.Chips.filter(item=>item.Type === 'Column'))?
                    index === 0 && index1 === 1?<b><IntlMessages id="Report"/></b>
                    :
                    index === 1 && index1 === 1?<b><IntlMessages id="appKontoModule.Description"/></b>:
                    index === 2?
                    isUndefined(ColumnC[index1-1])?"":<b>{ColumnC[index1-1].Meta}</b>
                    :""
                    :""
                }</TableCell>
              })
            }
              </TableRow>
      ))}
             {[...Array(6)].map((row,index) => (
        <TableRow key={index}>
            {
              [...Array(105)].map((item,index1)=>{
                return <TableCell style={{maxWidth:500,minWidth:index1 === 0?50:200,whiteSpace: "nowrap",overflow:"hidden",textOverflow: "ellipsis"}} 
                align="center" className={`${index1 === 0?classes.CellIndex:""} border`} key={index1}>
                    {
                    index1 === 0?index+4:
                    !isEmpty(props.Chips.filter(item=>item.Type === 'Column'))?
                    !isEmpty(ImportSamples)?
                    isUndefined(ColumnC[index1-1])?"":isUndefined(ImportSamples[index])?"":ImportSamples[index][ColumnC[index1-1].MetaN]
                    :""
                    :""
                    }
                   
                </TableCell>
              })
            }
        </TableRow>
      ))}
      
      </TableBody>
      </Table>
    </TableContainer>
        </div>
    );
}
export default ExcelVy;